// extracted by mini-css-extract-plugin
export default {"mainCover":"insights-cover_mainCover__3OVm+","cover_section":"insights-cover_cover_section__hmuUD","coverImg":"insights-cover_coverImg__rp4PC"};